module.exports = require('./components/TinyMCE');



/** WEBPACK FOOTER **
 ** ./lib/main.js
 **/